import { NgClass } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { ChipModel } from '../../../../models/chip.model';

@Component({
  selector: 'fdr-past-performance-ui-chips',
  imports: [NgClass],
  templateUrl: './chips.component.html',
  styleUrl: './chips.component.scss'
})
export class ChipsComponent {
  readonly chipsData = input.required<ChipModel[]>();
  readonly onPress = output<number>();
}
